module.exports = __webpack_public_path__ + "static/media/shopping-bag.c27cd55a.svg";